export const sinFoto= 'sinFoto'